import {WinMeter} from '@fantasmagames/slot/src/modules/winpresentation/WinMeter';

export class WinFieldWinMeter extends WinMeter {

	protected onUpdate(): void {
		if (this._winText) {
			if (this._valueWrapper.value === 0) {
				this._winText.visible = false;
			} else {
				this._winText.visible = true;
				this._winText.showNumber(this.format(this._valueWrapper.value, this._includeCurrencySign));
			}
			if (this._resolutionWidth && this._autoFitWinNumbers) {
				this.checkBounds();
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/winfield/WinFieldWinMeter.ts